'use strict';

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;

    // Prevent browser tooltip for checkboxes by setting custom validity
    $(this).find('input[type="checkbox"]').each(function () {
        if (this.required && !this.checked) {
            // Set custom validity to prevent browser tooltip
            this.setCustomValidity(' ');
        } else {
            this.setCustomValidity('');
        }
    });

    if (this.checkValidity && !this.checkValidity()) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        // Validate all inputs including checkboxes - trigger invalid event
        $(this).find('input, select').each(function () {
            if (!this.validity.valid) {
                $(this).trigger('invalid', this.validity);
            }
        });
    } else {
        // Even if form checkValidity passes, manually validate required checkboxes
        // because checkValidity might not catch unchecked required checkboxes
        $(this).find('input[type="checkbox"][required]').each(function () {
            if (!this.checked) {
                // Manually trigger validation by setting custom validity and checking
                this.setCustomValidity(' ');
                if (!this.checkValidity()) {
                    $(this).trigger('invalid', this.validity);
                    valid = false;
                }
                this.setCustomValidity('');
            }
        });
    }

    // Clear custom validity from checkboxes after validation
    $(this).find('input[type="checkbox"]').each(function () {
        this.setCustomValidity('');
    });

    return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
    var $form = $(form);
    $form.find('.form-control.is-invalid').removeClass('is-invalid');
    $form.find('input[type="checkbox"].is-invalid').removeClass('is-invalid');
    $form.find('input[type="radio"].is-invalid').removeClass('is-invalid');
    $form.find('.has-invalid-checkbox').removeClass('has-invalid-checkbox');
    $form.find('.has-invalid-radio').removeClass('has-invalid-radio');
    $form.find('.has-invalid-field').removeClass('has-invalid-field');
    $form.find('.invalid-feedback').hide().html('');
}

/**
 * Remove all input validation error messages.
 * @param {element} $input - input to be cleared
 * @param {element} $clearinputvalue - input value to be cleared or not. if true value set means it will be cleared.
 * @returns {void}
 */
function clearValidation($input, $clearinputvalue) {
    var $formGroup = $input.closest('.form-group');
    if ($clearinputvalue) {
        $input.removeClass('is-invalid').val('');
    }

    $formGroup.find('.invalid-feedback').hide();
    $formGroup.find('.reset-icon').removeClass('reset-btn-error');
}

module.exports = {
    invalid: function () {
        // Handle checkboxes - same pattern as other inputs
        $('form input[type="checkbox"]').on('invalid', function (e) {
            e.preventDefault();
            this.setCustomValidity('');
            var $checkbox = $(this);
            var $formGroup = $checkbox.closest('.form-group');
            var $container = $checkbox.closest('.form-check, .form-group');
            var $invalidFeedback = $container.find('.invalid-feedback');
            var checkboxId = $checkbox.attr('id');

            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                var appResources = window.appResources || {};
                var validationMessages = appResources.validationMessages || {};
                // Use custom error message - checkbox data-missing-error, or property file messages for terms/privacy
                if (this.validity.valueMissing && $checkbox.data('missing-error')) {
                    validationMessage = $checkbox.data('missing-error');
                } else if (this.validity.valueMissing && checkboxId === 'termsAndConditions') {
                    validationMessage = validationMessages.termsAndConditionsRequired || validationMessage;
                } else if (this.validity.valueMissing && checkboxId === 'privacyPolicy') {
                    validationMessage = validationMessages.privacyPolicyRequired || validationMessage;
                }

                $checkbox.addClass('is-invalid');
                $formGroup.addClass('has-invalid-checkbox');
                $container.addClass('has-invalid-field');

                // Find and show invalid-feedback
                if ($invalidFeedback.length) {
                    $invalidFeedback.html(validationMessage).css({
                        display: 'block',
                        visibility: 'visible'
                    }).removeClass('d-none');
                } else if (checkboxId) {
                    // Fallback: find by ID
                    $('#' + checkboxId + '-error').html(validationMessage).css({
                        display: 'block',
                        visibility: 'visible'
                    }).removeClass('d-none');
                }
            } else {
                $checkbox.removeClass('is-invalid');
                $formGroup.removeClass('has-invalid-checkbox');
                $container.removeClass('has-invalid-field');
                if ($invalidFeedback.length) {
                    $invalidFeedback.hide().html('');
                } else if (checkboxId) {
                    $('#' + checkboxId + '-error').hide().html('');
                }
            }
        });

        // Handle checkboxes separately - validate on change, clear validation when checked
        $('form input[type="checkbox"]').on('change', function () {
            var $checkbox = $(this);
            var $formGroup = $checkbox.closest('.form-group');
            // Clear custom validity to prevent browser tooltip
            this.setCustomValidity('');

            // If this is part of a mandatory checkbox group, validate the group
            if ($formGroup.hasClass('required') && $formGroup.is(':visible') && !$formGroup.hasClass('visually-hidden')) {
                var $groupCheckboxes = $formGroup.find('input[type="checkbox"]:visible').not('.visually-hidden');
                var hasAnyChecked = $groupCheckboxes.is(':checked');

                if (hasAnyChecked) {
                    // Clear validation if at least one is checked
                    $formGroup.removeClass('has-invalid-checkbox has-invalid-field');
                    $formGroup.find('.invalid-feedback').hide().html('');
                    // Also remove is-invalid from all checkboxes in the group
                    $groupCheckboxes.removeClass('is-invalid');
                } else {
                    // Show validation if none are checked
                    var errorMessage = $groupCheckboxes.first().data('missing-error') || 'Please select at least one option';
                    $formGroup.addClass('has-invalid-checkbox has-invalid-field');
                    $formGroup.find('.invalid-feedback').html(errorMessage).show();
                }
            }

            // Handle individual required checkboxes (not part of a group) or any checkbox when checked
            // Clear is-invalid class when checkbox is checked
            if ($checkbox.is(':checked')) {
                $checkbox.removeClass('is-invalid');
                // Only clear form-group classes if this is not part of a group (handled above)
                if (!$formGroup.hasClass('required') || $formGroup.find('input[type="checkbox"]').length === 1) {
                    $formGroup.removeClass('has-invalid-checkbox has-invalid-field');
                    $formGroup.find('.invalid-feedback').hide().html('');
                }
            }

            // Ensure checkbox has a value attribute if it doesn't
            if (!$checkbox.attr('value')) {
                $checkbox.attr('value', 'true');
            }
        });

        // Handle other inputs (exclude checkboxes)
        $('form input:not([type="checkbox"]), form select, form textarea').on('blur invalid', function (e) {
            e.preventDefault();
            this.setCustomValidity('');
            if (this.tagName.toLowerCase() === 'textarea') {
                var patternStr = $(this).attr('pattern');
                // Only proceed with regex validation if pattern attribute exists
                if (patternStr) {
                    var regex = new RegExp(patternStr);
                    var text = $(this).val();
                    var validationMsg = this.validationMessage;
                    var $textarea = $(this);
                    var $textareaFormGroup = $textarea.parents('.form-group');
                    if (regex.test(text) || text === '') {
                        $textarea.removeClass('is-invalid');
                        $textareaFormGroup.find('.invalid-feedback').hide();
                        return; // Exit early if validation passes
                    }
                    $textarea.addClass('is-invalid');
                    validationMsg = $textarea.data('pattern-mismatch');
                    $textareaFormGroup.find('.invalid-feedback').text(validationMsg).show();
                    return; // Exit if validation fails
                }
            }
            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                var $field = $(this);
                var $formGroup = $field.closest('.form-group');

                $field.addClass('is-invalid');
                // Add has-invalid-field class to form-group for error styling (matches registration flow)
                $formGroup.addClass('has-invalid-field');

                // Handle email typeMismatch (when type="email" and format is invalid)
                if (this.validity.typeMismatch && $field.data('pattern-mismatch')) {
                    validationMessage = $field.data('pattern-mismatch');
                }
                if (this.validity.patternMismatch && $field.data('pattern-mismatch')) {
                    validationMessage = $field.data('pattern-mismatch');
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $field.data('range-error')) {
                    validationMessage = $field.data('range-error');
                }
                if ((this.validity.tooLong || this.validity.tooShort)
                    && $field.data('range-error')) {
                    validationMessage = $field.data('range-error');
                }
                if (this.validity.valueMissing && $field.data('missing-error')) {
                    validationMessage = $field.data('missing-error');
                }
                $formGroup.find('.invalid-feedback').text(validationMessage).show();
                $formGroup.find('.reset-icon').addClass('reset-btn-error');
            } else {
                var $formGroupValid = $(this).parents('.form-group');
                $(this).removeClass('is-invalid');
                // Remove has-invalid-field class when field becomes valid
                $formGroupValid.removeClass('has-invalid-field');
                $formGroupValid.find('.invalid-feedback').hide();
                $formGroupValid.find('.reset-icon').removeClass('reset-btn-error');
            }
        });

        // Handle radio button change events - clear validation for all radios in the group when any is selected
        $('form input[type="radio"]').on('change', function () {
            var radioName = this.name;
            var $radio = $(this);
            var $formGroup = $radio.closest('.form-group');

            if (radioName) {
                // Clear invalid state from all radios in this group
                $('input[name="' + radioName + '"]').removeClass('is-invalid');

                // If radio is checked, clear validation errors
                if ($radio.is(':checked')) {
                    $formGroup.removeClass('has-invalid-radio has-invalid-field');
                    $formGroup.find('.invalid-feedback').hide().html('');
                }
                $formGroup.find('.reset-icon').removeClass('reset-btn-error');
            }
        });
    },

    submit: function () {
        $('form').on('submit', function (e) {
            var isValid = validateForm.call(this, e);
            var form = $(this).serialize();
            var customerForm = $('.customer-info-form').serialize();
            var shippingForm = $('.shipping-form').serialize();
            if (!isValid && ((form === customerForm) || (form === shippingForm))) {
                $('.global-error').removeClass('d-none');
            }
            return isValid;
        });
    },

    buttonClick: function () {
        $('form button[type="submit"], form input[type="submit"]').on('click', function () {
            // clear all errors when trying to submit the form
            clearForm($(this).parents('form'));
        });
    },

    onClick: function () {
        $('form input, form select').on('input', function () {
            $(this).siblings('.reset-input-text').toggle(this.value.length > 0);
        });
    },

    functions: {
        validateForm: function (form, event) {
            // Ensure form is a DOM element (not jQuery object) for checkValidity() to work
            // $(form) handles both DOM elements and jQuery objects
            var formElement = $(form)[0] || form;
            return validateForm.call(formElement, event || null);
        },
        validateTrackOrderForm: function (form, event) {
            // Ensure form is a DOM element (not jQuery object) for checkValidity() to work
            // $(form) handles both DOM elements and jQuery objects
            var formElement = $(form)[0] || form;
            return validateForm.call(formElement, event || null);
        },
        clearForm: clearForm,
        showFieldError: function (field, message) {
            // Show validation error for a field - global function used by registration and edit flows
            var $field = $(field);
            var $formGroup = $field.closest('.form-group');

            // Add is-invalid class to the field
            $field.addClass('is-invalid');

            // Add has-invalid-field class to form-group for error styling
            $formGroup.addClass('has-invalid-field');

            // Also add has-invalid-field to containers (for registration flow styling)
            var $container = $field.closest('.question-container, .journey-selection-wrapper, .registration-step.step-1');
            if ($container.length > 0) {
                $container.addClass('has-invalid-field');
            }

            // Find and show invalid-feedback div
            var $invalidFeedback = $formGroup.find('.invalid-feedback');
            if ($invalidFeedback.length === 0) {
                // Try finding by ID pattern (fieldName-error)
                var fieldId = $field.attr('id');
                if (fieldId) {
                    $invalidFeedback = $('#' + fieldId + '-error');
                }
            }

            if ($invalidFeedback.length > 0) {
                $invalidFeedback.text(message || 'This field is required').show();
            } else {
                // Create invalid-feedback if it doesn't exist
                $formGroup.append('<div class="invalid-feedback">' + (message || 'This field is required') + '</div>');
            }
        },
        validateMandatoryCheckboxGroups: function ($container) {
            // Validate mandatory checkbox groups (at least one must be selected)
            // This is a global function that can be used anywhere
            var isValid = true;
            var $scope = $container || $('form');

            // Find all required form groups - use a more comprehensive selector
            // This will find form-groups with required class anywhere in the scope
            $scope.find('.form-group.required').each(function () {
                var $formGroup = $(this);

                // Skip validation if form group is hidden or has visually-hidden class
                // Also check if parent containers are hidden
                if ($formGroup.hasClass('visually-hidden')
                    || !$formGroup.is(':visible')
                    || $formGroup.closest('.visually-hidden').length > 0) {
                    return;
                }

                // Find checkboxes - use EXACT same approach as checkbox change handler for consistency
                var $checkboxes = $formGroup.find('input[type="checkbox"]:visible').not('.visually-hidden').filter(function () {
                    return !$(this).prop('disabled');
                });

                // Only validate if this form group contains checkboxes (multi-select)
                // Skip if it contains radio buttons (radio groups are validated separately)
                var $radios = $formGroup.find('input[type="radio"]').filter(function () {
                    var $radio = $(this);
                    return $radio.is(':visible')
                        && !$radio.closest('.visually-hidden').length
                        && !$radio.prop('disabled');
                });

                if ($checkboxes.length > 0 && $radios.length === 0) {
                    // Use EXACT same logic as checkbox change handler
                    var hasChecked = $checkboxes.is(':checked');
                    var errorMessage = $checkboxes.first().data('missing-error') || 'Please select at least one option';

                    if (!hasChecked) {
                        isValid = false;
                        // Don't add is-invalid to checkboxes to avoid red labels
                        // Only add classes to form-group for background styling
                        $formGroup.addClass('has-invalid-checkbox has-invalid-field');

                        // Use EXACT same approach as checkbox change handler
                        var $invalidFeedback = $formGroup.find('.invalid-feedback');
                        if ($invalidFeedback.length > 0) {
                            $invalidFeedback.html(errorMessage).show();
                        } else {
                            // Try finding by ID pattern
                            var fieldName = $checkboxes.first().attr('name');
                            if (fieldName) {
                                // Extract field name (e.g., "applications" from "dwfrm_chocolateUseAndConsumptionQuestions_chocolateUseAndConsumption_applications")
                                var parts = fieldName.split('_');
                                var fieldBase = parts[parts.length - 1]; // Get last part
                                $invalidFeedback = $('#' + fieldBase + '-error');
                            }

                            if ($invalidFeedback.length > 0) {
                                $invalidFeedback.html(errorMessage).show();
                            } else {
                                // Create invalid-feedback if it doesn't exist
                                $formGroup.append('<div class="invalid-feedback">' + errorMessage + '</div>');
                            }
                        }
                    } else {
                        // Clear validation if at least one is checked
                        $formGroup.removeClass('has-invalid-checkbox has-invalid-field');
                        $formGroup.find('.invalid-feedback').hide().html('');
                    }
                }
            });

            return isValid;
        },
        validateMandatoryRadioGroups: function ($container) {
            // Validate mandatory radio button groups (one must be selected)
            // This is a global function that can be used anywhere
            var isValid = true;
            var $scope = $container || $('form');

            // Find all required form groups - use a more comprehensive selector
            // This will find form-groups with required class anywhere in the scope
            $scope.find('.form-group.required').each(function () {
                var $formGroup = $(this);
                // Skip validation if form group is hidden or has visually-hidden class
                // Also check if parent containers are hidden
                if ($formGroup.hasClass('visually-hidden')
                    || !$formGroup.is(':visible')
                    || $formGroup.closest('.visually-hidden').length > 0) {
                    return;
                }

                // Find radio buttons - including nested ones
                var $radios = $formGroup.find('input[type="radio"]').filter(function () {
                    var $radio = $(this);
                    return $radio.is(':visible')
                        && !$radio.closest('.visually-hidden').length
                        && !$radio.prop('disabled');
                });

                // Only validate if this form group contains radio buttons
                // Skip if it also contains checkboxes (checkbox groups take precedence)
                var $checkboxes = $formGroup.find('input[type="checkbox"]').filter(function () {
                    var $checkbox = $(this);
                    return $checkbox.is(':visible')
                        && !$checkbox.closest('.visually-hidden').length
                        && !$checkbox.prop('disabled');
                });

                if ($radios.length > 0 && $checkboxes.length === 0) {
                    var hasChecked = $radios.is(':checked');
                    var errorMessage = $radios.first().data('missing-error') || 'Please select an option';

                    if (!hasChecked) {
                        isValid = false;
                        // Don't add is-invalid to radio buttons to avoid red labels
                        // Only add classes to form-group for background styling
                        $formGroup.addClass('has-invalid-radio has-invalid-field');
                        var $invalidFeedback = $formGroup.find('.invalid-feedback');
                        if ($invalidFeedback.length > 0) {
                            $invalidFeedback.html(errorMessage).show();
                        } else {
                            // Create invalid-feedback if it doesn't exist
                            $formGroup.append('<div class="invalid-feedback">' + errorMessage + '</div>');
                        }
                    } else {
                        // Clear validation if one is checked
                        $formGroup.removeClass('has-invalid-radio has-invalid-field');
                        $formGroup.find('.invalid-feedback').hide();
                    }
                }
            });

            return isValid;
        },
        /**
         * Validates all forms within a container. Use for multi-form sections (e.g. checkout with
         * separate billing and payment-method forms). Terms and privacy checkboxes work globally
         * via the invalid handler (built-in messages for termsAndConditions/privacyPolicy by id).
         * @param {jQuery} $container - Container holding one or more forms to validate
         * @returns {boolean} - True if all forms are valid
         */
        validateFormsInContainer: function ($container) {
            var isValid = true;
            var $forms = $container.find('form');
            var self = this;

            $forms.each(function () {
                var form = this;
                clearForm(form);
                if (!validateForm.call(form)) {
                    isValid = false;
                }
                if (!self.validateMandatoryCheckboxGroups($(form))) {
                    isValid = false;
                }
                if (!self.validateMandatoryRadioGroups($(form))) {
                    isValid = false;
                }
            });

            return isValid;
        }
    },

    errorMessageValidationHandlers: function () {
        var $inputContainer = $('.custom-input-container');

        $inputContainer.on('click', '.reset-input-text', function (e) {
            e.preventDefault();
            var $formGroup = $(this).closest('.form-group');
            var $input = $formGroup.find('input');
            clearValidation($input, true);
            $(this).hide();
        });

        $inputContainer.on('focus', 'input, select', function () {
            clearValidation($(this), false);
        });
    },
    handlePhoneWithZero: function () {
        $('.js-phone').on('input', function () {
            var phone = $(this).val();
            if (phone.startsWith('0')) {
                $(this).val(phone.substring(1));
            }
        });
    }
};
